module.exports = __webpack_public_path__ + "static/assets/c4e57ae74e6f8faa69dd84f67fd9fc8f.jpg";